import { IComment } from '../../../../../../../store/model/card/types/IComment';
import { TBoardId, TCardId } from '../../../../../../../types/types';
import { EAsidePanelProperty } from '../../../../../aside_panel/asidePanel/components/AsidePanel/types';
import { ESettingsSectionType } from '../../../SettingsSection/types';

export enum ECommentListDirection {
    DOWN = 'DOWN',
    UP = 'UP',
}

export interface ICommentsListFields {
    boardId: TBoardId;
    cardId: TCardId;
    comments: IComment[];
    commentCount: number;
    direction?: ECommentListDirection;
    isReadonly: boolean;
    lastCommentSeenTime?: number;
    openedProperty?: EAsidePanelProperty;
    sectionType?: ESettingsSectionType;
}

export interface ICommentsListEvents {
    onClose?: () => void;
    onEdit?: () => void;
    onLoad: () => Promise<void>;
    onResetUnseen?: () => void;
}

export interface ICommentsListProps extends
    ICommentsListFields,
    ICommentsListEvents
{}
